import {
  BookOpenCheckIcon,
  Clock3Icon,
  FileQuestionIcon,
  GraduationCapIcon,
  CalculatorIcon,
  WalletCardsIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const painPoints: { icon: LucideIcon; text: string }[] = [
  { icon: Clock3Icon, text: 'You’re up past midnight building tomorrow’s worksheet from scratch.' },
  { icon: FileQuestionIcon, text: 'A student asks “when will I ever use this?” — and you freeze.' },
  { icon: GraduationCapIcon, text: 'You’re juggling multiple grade levels and nothing lines up.' },
  { icon: CalculatorIcon, text: 'You re-explain the same steps every week with no practice ready to hand out.' },
  { icon: WalletCardsIcon, text: 'You have no budget for expensive workbook programs.' },
  { icon: BookOpenCheckIcon, text: 'You grade every page by hand because the answer keys never come included.' },
]
